










import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import BpcPageTitle from '@shared/layouts/components/page-title/page-title.vue';
import ShoppingCartContinueShopping from '@accounting/components/shopping-cart/shopping-cart-continue-shopping.vue';
import PaymentCheckoutStatus from '@accounting/components/payment-checkout-status.vue';

@Component({
  name: 'bpc-payment-cancel-page',
  components: {
    'bpc-page-title': BpcPageTitle,
    'bpc-shopping-cart-continue-shopping': ShoppingCartContinueShopping,
    'bpc-payment-checkout-status': PaymentCheckoutStatus,
  },
})
export default class PaymentCancelPage extends Vue {
  mounted() {
    console.log(this.$route.query['session_id']);
  }

  get sessionId(): string {
    return String(this.$route.query['session_id']);
  }
}
